import React from 'react';

// Types
import { MetricSlugs } from '../../ManagerDashboardData.constants';

// Components
import MetricsWrapper from '../MetricsWrapper';
import WpDataTable, { SortDirection } from 'Wpds/components/table/WpDataTable';

type Props = {
  data;
};

const TeamGoals = ({ data }: Props) => {
  const goals = data.reports.map(report => ({
    name: report.user.name,
    created: report.goals.goals_created,
    completed: report.goals.goals_completed,
    open: report.goals.goals_open,
  }));

  return (
    <MetricsWrapper slug={MetricSlugs.team_goals}>
      <WpDataTable
        columns={[
          { name: 'Name', selector: 'name', noWrap: true, initialSort: SortDirection.ASC },
          { name: 'Created', selector: 'created' },
          { name: 'Completed', selector: 'completed' },
          { name: 'Open', selector: 'open' },
        ]}
        rows={goals}
      />
    </MetricsWrapper>
  );
};

export default TeamGoals;
